<template>
  <section>
    <button class="heading" :class="{ expand }" @click="expand = !expand">
      <span>IMAGE & VIDEO CREDITS</span>
      <i class="icon icon-arrow-down-1"></i>
    </button>

    <div class="credits" v-if="expand" :class="{ expand }">
      <a v-for="{ label, url } in mediaCredits" :href="url" target="_blank" rel="noreferrer noopener">{{ label }}</a>
    </div>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import { computed, ref } from 'vue'

const expand = ref(false)
const {
  data: { itinerary },
} = useItineraryStore()

const mediaCredits = computed(() => {
  const videoCredits = itinerary.videoCredits.filter(v => v.name && v.url).map(v => ({ label: v.name, url: v.url }))

  const imageCredits = itinerary.images
    .filter(i => i.description && i.authorName && i.authorUrl)
    .map(i => ({ label: `${i.description} - ${i.authorName}`, url: i.authorUrl }))

  return [...videoCredits, ...imageCredits]
})
</script>

<style lang="scss" scoped>
.heading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: $brand-primary;
  font-weight: 600;

  &.expand {
    margin-bottom: 24px;

    .icon {
      transform: rotate(180deg);
    }
  }
}

.icon {
  transition: transform 100ms ease-in;
}

.credits {
  @include flex-column(16px);
}
</style>
